import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';
import 'moment-duration-format';
import clsx from 'classnames';

// Material UI
import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { getGlobalClasses } from '../../themes';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import CalendarSvg from '../../images/icons/coloredCalendar.svg';
import AuthUserContainer from '../../containers/AuthUser';
import TimeClockPermissionContainer from '../../containers/TimeClock/TimeClockPermission';
import PropTypes from 'prop-types';
import { post } from '../../modules/utility';
import Button from '@material-ui/core/Button';
import ClockInEmployeeDialog from '../../components/dialogs/ClockInEmployeeDialog';
import ClockOutEmployeeDialog from '../../components/dialogs/ClockOutEmployeeDialog';
import UpdateEmployeeTimeShiftDialog from '../../components/dialogs/UpdateEmployeeTimeShiftDialog';
import EnhancedTable from '../../components/table/EnhancedTable';
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import UpdateIcon from '@material-ui/icons/Update';
import RemoveTimeShiftDialog from '../../components/dialogs/RemoveTimeShiftDialog';
import TextField from '@material-ui/core/TextField';
import { isFiltered } from '../../libs/tableUtilities';
import TimeClockLocationSelect from '../../components/advancedForm/TimeClockLocationSelect';
import UpdateEmployeeClockInDialog from '../../components/dialogs/UpdateEmployeeClockInDialog';
import AddEmployeeTimeShiftDialog from '../../components/dialogs/AddEmployeeTimeShiftDialog';
import FormCheckbox from '../../components/form/FormCheckbox';
import SectionHeader from '../../components/SectionHeader';
import localStorage from '../../libs/localStorage';
//import Paper from "@material-ui/core/Paper";
import ShiftTable from './ShiftTable';

export function formatDuration(d) {
	return moment.duration(d).format('d [days], h [hrs], m [min]');
}

function storeKey(key) {
	return `/timeClockDashboard-${key}`;
}

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		calendarIcon: {
			display: 'inline-block',
			width: 48,
			height: 48,
			backgroundImage: `url('${CalendarSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		pickCardTitleContainer: {
			display: 'flex',
			alignContent: 'center',
			alignItems: 'center',
		},
		pickerCardTitle: {
			paddingLeft: 10,
			fontSize: 28,
			color: '#333',
			textDecoration: 'none',
			fontWeight: 200,
		},
		infoCard: {
			marginBottom: 30,
		},
		cardTop: {
			color: '#fff',
			letterSpacing: 2,
			textTransform: 'uppercase',
			fontWeight: 800,
			fontSize: 14,
			padding: '15px 0px 15px 20px',
		},
		infoCardTop: {
			backgroundColor: '#4CAF50',
		},
		infoFlaggedTop: {
			backgroundColor: '#f44336',
		},
		recentCardTop: {
			backgroundColor: '#03A9F4',
		},
		resetCardTop: {
			backgroundColor: '#F57F17',
		},
		infoCardContent: {
			padding: 20,
		},
		clockButton: {
			fontSize: 16,
			borderRadius: '100px',
			padding: '12px 40px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		totalContainer: {
			textAlign: 'left',
			display: 'inline-block',
			marginRight: 20,
			padding: 15,
		},
		totalLabel: {
			textTransform: 'uppercase',
			color: '#666',
			fontSize: 15,
		},
		totalValue: {
			fontSize: 30,
			fontWeight: 500,
		},
		bottomRow: {
			borderTop: `1px solid #eee`,
			paddingTop: 20,
			display: 'flex',
			alignItems: 'center',
		},
		removeButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
	};
};

class TimeClockDashboard extends Component {
	constructor(props) {
		super(props);

		let showRecentlyCompleted = localStorage.getItem(storeKey('showRecentlyCompleted'));
		let showCurrentlyClockedIn = localStorage.getItem(storeKey('showCurrentlyClockedIn'));
		let show34HourReset = localStorage.getItem(storeKey('show34HourReset'));

		this.state = {
			order: 'asc',
			orderBy: 'displayName',
			filter: '',
			filterTimeClockLocationId: '',
			isClockInEmployeeDialogOpen: false,
			isClockOutEmployeeDialogOpen: false,
			isUpdateEmployeeDialogOpen: false,
			isAddEmployeeDialogOpen: false,
			timeClockShiftForClockOut: undefined,
			isRemoveShiftDialogOpen: false,
			timeClockShiftForRemove: undefined,
			isChangeClockInOpen: false,
			timeClockShiftForUpdate: null,
			timeClockShiftForClockIn: null,
			refreshId: 0,
			showRecentlyCompleted: _.isUndefined(showRecentlyCompleted) ? true : showRecentlyCompleted,
			showCurrentlyClockedIn: _.isUndefined(showCurrentlyClockedIn) ? true : showCurrentlyClockedIn,
			show34HourReset: _.isUndefined(show34HourReset) ? true : show34HourReset,
		};
	}

	componentDidMount() {
		if (_.isUndefined(this.props.myTimeClockPermissions)) {
			this.props.getMyTimeClockPermissions();
		}
		this.getShiftInfo();
		this.getShiftAnalysis();
	}

	getShiftInfo = (doRefresh) => {
		post({
			method: 'timeClockShift.manager.getLastShiftInfo',
			params: {},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						searching: false,
						searchErrors: err,
					});
				}

				const newState = {
					searching: false,
					getLastShiftInfoResult: r,
				};
				if (doRefresh) {
					newState.refreshId = this.state.refreshId + 1;
				}
				this.setState(newState);
			},
		});
	};

	getShiftAnalysis = () => {
		post({
			method: 'timeClockShift.manager.getShiftAnalysis',
			params: {},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						searching: false,
						searchErrors: err,
					});
				}

				this.setState({
					searching: false,
					getShiftAnalysisResult: r,
				});
			},
		});
	};

	clockInEmployee = () => {
		this.setState({
			isClockInEmployeeDialogOpen: true,
		});
	};
	handleCloseClockInEmployeeDialog = () => {
		this.setState({
			isClockInEmployeeDialogOpen: false,
		});
	};
	afterClockInEmployee = () => {
		this.getShiftInfo(true);
	};

	clockOutEmployee = ({ timeClockShift }) => {
		this.setState({
			timeClockShiftForClockOut: timeClockShift,
			isClockOutEmployeeDialogOpen: true,
		});
	};
	handleCloseClockOutEmployeeDialog = () => {
		this.setState({
			timeClockShiftForClockOut: null,
			isClockOutEmployeeDialogOpen: false,
		});
	};
	afterClockOutEmployee = () => {
		this.getShiftInfo(true);
	};

	addEmployee = () => {
		this.setState({
			isAddEmployeeDialogOpen: true,
		});
	};
	handleCloseAddEmployeeDialog = () => {
		this.setState({
			isAddEmployeeDialogOpen: false,
		});
	};

	updateEmployee = ({ timeClockShift }) => {
		this.setState({
			timeClockShiftForUpdate: timeClockShift,
			isUpdateEmployeeDialogOpen: true,
		});
	};
	handleCloseUpdateEmployeeDialog = () => {
		this.setState({
			timeClockShiftForUpdate: null,
			isUpdateEmployeeDialogOpen: false,
		});
	};

	changeClockInOpen = ({ timeClockShift }) => {
		this.setState({
			timeClockShiftForClockIn: timeClockShift,
			isChangeClockInOpen: true,
		});
	};
	changeClockInClose = () => {
		this.setState({
			timeClockShiftForClockIn: null,
			isChangeClockInOpen: false,
		});
	};

	removeShift = ({ timeClockShift }) => {
		this.setState({
			timeClockShiftForRemove: timeClockShift,
			isRemoveShiftDialogOpen: true,
		});
	};

	handleCloseRemoveShiftDialog = () => {
		this.setState({
			timeClockShiftForRemove: null,
			isRemoveShiftDialogOpen: false,
		});
	};

	afterUpdateEmployee = () => {
		this.getShiftInfo(true);
		this.getShiftAnalysis();
	};

	afterRemoveShift = () => {
		this.getShiftInfo();
	};

	handleFilter = (event) => {
		this.setState({ filter: event.target.value });
	};
	handleLocationFilter = (value, path) => {
		this.setState({ [path]: value });
	};

	handleCheck = (path) => {
		const newVal = !this.state[path];
		localStorage.setItem(storeKey(path), newVal);
		this.setState({ [path]: newVal });
	};

	render() {
		const {
			classes,
			permissions,
			myTimeClockPermissions,
			myCanViewUserIds,
			myCanModifyUserIds,
			userMap,
		} = this.props;

		const { filter, filterTimeClockLocationId } = this.state;

		if (!permissions || !_.includes(permissions, 'canViewTimeClocks')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}

		if (!myTimeClockPermissions) {
			return <div className={classes.globalFetching}>Fetching your permissions...</div>;
		}

		let totalEmployees = 0;
		if (_.isArray(myCanViewUserIds)) {
			myCanViewUserIds.forEach((myCanViewUserId) => {
				const user = userMap[myCanViewUserId] || {};
				if (user.isHidden) {
					return;
				}
				totalEmployees++;
			});
		}

		const cantModifyUsers = _.isEmpty(myCanModifyUserIds);

		const { showCurrentlyClockedIn, showRecentlyCompleted } = this.state;
		const currentMd = !showRecentlyCompleted ? 12 : 6;
		const recentMd = !showCurrentlyClockedIn ? 12 : 6;

		return (
			<Fragment>
				<div className={classes.globalMainHeadline}>Time Clock Dashboard</div>

				<Grid container spacing={2}>
					<Grid item md={12}>
						<Paper className={classes.globalMainPaper} style={{ paddingBottom: 30 }}>
							<Grid container spacing={2}>
								<Grid item xs={12} md={12}>
									<div className={classes.pickCardTitleContainer}>
										<div className={classes.calendarIcon} />
										<span className={classes.pickerCardTitle}>
											{moment().format('dddd, MMMM Do YYYY')}
										</span>
									</div>
								</Grid>

								<Grid item md={12} className={classes.bottomRow}>
									<div className={classes.totalContainer}>
										<div className={classes.totalLabel}>TOTAL EMPLOYEES</div>
										<div className={classes.totalValue}>{totalEmployees}</div>
									</div>

									<Button
										onClick={this.clockInEmployee}
										variant="outlined"
										color="primary"
										className={classes.clockButton}
										disabled={cantModifyUsers}
									>
										Clock In Employee
									</Button>

									<Button
										onClick={this.clockOutEmployee}
										variant="outlined"
										color="primary"
										className={classes.clockButton}
										disabled={cantModifyUsers}
									>
										Clock Out Employee
									</Button>

									<Button
										onClick={this.addEmployee}
										variant="outlined"
										color="primary"
										className={classes.clockButton}
										disabled={cantModifyUsers}
									>
										Add Shift For Employee
									</Button>
								</Grid>
							</Grid>
						</Paper>

						<Grid container spacing={2}>
							<Grid item md={12}>
								<Paper className={classes.globalMainPaper} style={{ paddingBottom: 30 }}>
									<Grid container spacing={2}>
										<Grid item xs={8} md={6}>
											<TextField
												value={filter}
												onChange={this.handleFilter}
												label="Filter employee"
												fullWidth
											/>
										</Grid>
										<Grid item xs={8} md={6}>
											<TimeClockLocationSelect
												label="Filter by Location"
												path="filterTimeClockLocationId"
												value={filterTimeClockLocationId}
												onChange={this.handleLocationFilter}
											/>
										</Grid>

										<SectionHeader label="Customize Dashboard Modules" gridProps={{ md: 12 }} />
										<FormCheckbox
											label="Currently Clocked In"
											path="showCurrentlyClockedIn"
											value={'showCurrentlyClockedIn'}
											checked={this.state.showCurrentlyClockedIn}
											onChange={() => this.handleCheck('showCurrentlyClockedIn')}
											gridProps={{ md: 4 }}
										/>
										<FormCheckbox
											label="Recently Completed"
											path="showRecentlyCompleted"
											value={'showRecentlyCompleted'}
											checked={this.state.showRecentlyCompleted}
											onChange={() => this.handleCheck('showRecentlyCompleted')}
											gridProps={{ md: 4 }}
										/>
										<FormCheckbox
											label="34 Hour Reset"
											path="show34HourReset"
											value={'show34HourReset'}
											checked={this.state.show34HourReset}
											onChange={() => this.handleCheck('show34HourReset')}
											gridProps={{ md: 4 }}
										/>
									</Grid>
								</Paper>
							</Grid>
						</Grid>

						<ClockInEmployeeDialog
							open={this.state.isClockInEmployeeDialogOpen}
							onClose={this.handleCloseClockInEmployeeDialog}
							myCanModifyUserIds={myCanModifyUserIds}
							afterSave={this.afterClockInEmployee}
						/>

						<ClockOutEmployeeDialog
							open={this.state.isClockOutEmployeeDialogOpen}
							onClose={this.handleCloseClockOutEmployeeDialog}
							timeClockShift={this.state.timeClockShiftForClockOut}
							userMap={this.props.userMap}
							afterSave={this.afterClockOutEmployee}
						/>

						<AddEmployeeTimeShiftDialog
							open={this.state.isAddEmployeeDialogOpen}
							onClose={this.handleCloseAddEmployeeDialog}
							myCanModifyUserIds={myCanModifyUserIds}
							userMap={this.props.userMap}
							afterSave={this.afterUpdateEmployee}
						/>

						<UpdateEmployeeTimeShiftDialog
							open={this.state.isUpdateEmployeeDialogOpen}
							onClose={this.handleCloseUpdateEmployeeDialog}
							timeClockShift={this.state.timeClockShiftForUpdate}
							userMap={this.props.userMap}
							afterSave={this.afterUpdateEmployee}
						/>

						<UpdateEmployeeClockInDialog
							open={this.state.isChangeClockInOpen}
							onClose={this.changeClockInClose}
							timeClockShift={this.state.timeClockShiftForClockIn}
							userMap={this.props.userMap}
							afterSave={this.afterUpdateEmployee}
						/>

						<RemoveTimeShiftDialog
							open={this.state.isRemoveShiftDialogOpen}
							onClose={this.handleCloseRemoveShiftDialog}
							timeClockShift={this.state.timeClockShiftForRemove}
							userMap={this.props.userMap}
							afterSave={this.afterRemoveShift}
						/>
					</Grid>

					{this.renderFlaggedCard()}

					<Grid item xs={12} lg={currentMd}>
						{this.renderClockedInCard()}
						{this.render34HourResetCard()}
					</Grid>
					<Grid item xs={12} lg={recentMd}>
						{this.renderRecentCompletedShiftsCard()}
					</Grid>
				</Grid>
			</Fragment>
		);
	}

	flaggedCallback = (rows) => {
		if (!_.isEmpty(rows)) {
			this.setState({ showFlaggedCard: true });
		}
	};
	renderFlaggedCard = () => {
		const { classes } = this.props;
		const display = this.state.showFlaggedCard ? 'block' : 'none';

		return (
			<Grid item xs={12} style={{ display }}>
				<Card classes={{ root: classes.infoCard }}>
					<div className={clsx(classes.cardTop, classes.infoFlaggedTop)}>
						Your Employees With Flagged Shifts
					</div>
					<div className={classes.infoCardContent}>
						<ShiftTable
							method="timeClockShift.manager.getFlaggedShifts"
							params={{}}
							onDataCallback={this.flaggedCallback}
						/>
					</div>
				</Card>
			</Grid>
		);
	};

	renderClockedInCard = () => {
		const { classes } = this.props;
		const { getLastShiftInfoResult, showCurrentlyClockedIn } = this.state;

		if (!showCurrentlyClockedIn) {
			return null;
		}

		return (
			<Card classes={{ root: classes.infoCard }}>
				<div className={clsx(classes.cardTop, classes.infoCardTop)}>
					Currently clocked in employees
				</div>

				<div className={classes.infoCardContent}>
					{!getLastShiftInfoResult && (
						<div className={classes.globalFetching}>Fetching your shifts...</div>
					)}
					{!!getLastShiftInfoResult && this.renderCurrentShifts()}
				</div>
			</Card>
		);
	};

	renderCurrentShifts = () => {
		const { getLastShiftInfoResult, filterTimeClockLocationId, filter } = this.state;

		const c = getLastShiftInfoResult.collections;
		const userMap = _.keyBy(_.get(c, 'userCollection', []), 'userId');
		const timeClockShifts = _.get(c, 'timeClockShiftCollection', []);
		const now = moment();

		const columns = [
			{ label: 'Employee', sortId: 'fullName', displayId: 'fullName' },
			{
				label: 'Clock In Time',
				sortId: 'clockInDateTime',
				displayId: 'clockInDisplay',
			},
			{
				label: 'Current Duration',
				sortId: 'durationInSeconds',
				displayId: 'formattedDuration',
			},
			{
				label: 'Fix',
				sortId: 'fix',
				isNotSortable: true,
				displayId: 'fixButton',
			},
		];

		const rows = timeClockShifts.reduce((acc, timeClockShift) => {
			const {
				timeClockShiftId,
				clockInDateTime,
				clockOutDateTime,
				shiftForUserId,
				timeClockLocationId,
			} = timeClockShift;
			if (clockOutDateTime) {
				return acc;
			}

			const user = userMap[shiftForUserId] || {
				firstName: 'Missing',
				lastName: '',
			};
			const { trainingAtLocationId } = user;
			if (
				filterTimeClockLocationId &&
				filterTimeClockLocationId !== timeClockLocationId &&
				filterTimeClockLocationId !== trainingAtLocationId
			) {
				return acc;
			}

			timeClockShift.key = timeClockShiftId;
			timeClockShift.fullName = `${user.firstName} ${user.lastName}`;
			timeClockShift.firstName = user.firstName;
			timeClockShift.lastName = user.lastName;

			const clockInMoment = moment(clockInDateTime);
			timeClockShift.clockInFormatted = clockInMoment.format('M/D h:mm a');
			timeClockShift.clockInDisplay = (
				<Button
					variant="outlined"
					startIcon={<UpdateIcon />}
					style={{ whiteSpace: 'nowrap' }}
					onClick={() => {
						this.changeClockInOpen({ timeClockShift });
					}}
				>
					{timeClockShift.clockInFormatted}
				</Button>
			);

			const duration = moment.duration(now.diff(clockInMoment));
			timeClockShift.formattedDuration = formatDuration(duration);
			timeClockShift.durationInSeconds = duration.asSeconds();

			timeClockShift.fixButton = (
				<Button
					onClick={() => {
						this.clockOutEmployee({ timeClockShift });
					}}
				>
					Clock Out
				</Button>
			);

			if (
				isFiltered({
					filter,
					row: timeClockShift,
					fields: ['firstName', 'lastName'],
				})
			) {
				return acc;
			}

			acc.push(timeClockShift);
			return acc;
		}, []);

		return (
			<EnhancedTable
				rows={rows}
				columns={columns}
				isDense={true}
				defaultOrder={'desc'}
				defaultOrderBy={'durationInSeconds'}
				refreshId={this.state.refreshId}
			/>
		);
	};

	renderCompletedShifts = () => {
		const { classes } = this.props;
		const { getLastShiftInfoResult, filter, filterTimeClockLocationId } = this.state;
		const c = getLastShiftInfoResult.collections;
		const userMap = _.keyBy(_.get(c, 'userCollection', []), 'userId');
		const timeClockShifts = _.get(c, 'timeClockShiftCollection', []);

		const columns = [
			{ label: 'Employee', sortId: 'fullName', displayId: 'fullName' },
			{
				label: 'Clock In',
				sortId: 'clockInDateTime',
				displayId: 'clockInFormatted',
			},
			{
				label: 'Clock Out',
				sortId: 'clockOutDateTime',
				displayId: 'clockOutFormatted',
			},
			{
				label: 'Shift Duration',
				sortId: 'durationInSeconds',
				displayId: 'formattedDuration',
			},
			{
				label: 'Fix',
				sortId: 'fix',
				isNotSortable: true,
				displayId: 'fixButton',
			},
		];

		const rows = timeClockShifts.reduce((acc, timeClockShift) => {
			const {
				timeClockShiftId,
				clockInDateTime,
				clockOutDateTime,
				shiftForUserId,
				timeClockLocationId,
			} = timeClockShift;
			if (!clockOutDateTime) {
				return acc;
			}
			if (filterTimeClockLocationId && filterTimeClockLocationId !== timeClockLocationId) {
				return acc;
			}

			timeClockShift.key = timeClockShiftId;
			const user = userMap[shiftForUserId] || {
				firstName: 'Missing',
				lastName: '',
			};
			timeClockShift.fullName = `${user.firstName} ${user.lastName}`;
			timeClockShift.firstName = user.firstName;
			timeClockShift.lastName = user.lastName;

			const clockInMoment = moment(clockInDateTime);
			timeClockShift.clockInFormatted = clockInMoment.format('M/D h:mm a');

			const clockOutMoment = moment(clockOutDateTime);
			timeClockShift.clockOutFormatted = clockOutMoment.format('M/D h:mm a');

			const duration = moment.duration(clockOutMoment.diff(clockInMoment));
			timeClockShift.formattedDuration = formatDuration(duration);
			timeClockShift.durationInSeconds = duration.asSeconds();

			timeClockShift.fixButton = (
				<div style={{ whiteSpace: 'nowrap' }}>
					<Button
						onClick={() => {
							this.updateEmployee({ timeClockShift });
						}}
					>
						Update
					</Button>

					<IconButton
						className={classes.removeButton}
						onClick={() => {
							this.removeShift({ timeClockShift });
						}}
					>
						<DeleteIcon />
					</IconButton>
				</div>
			);

			if (
				isFiltered({
					filter,
					row: timeClockShift,
					fields: ['firstName', 'lastName'],
				})
			) {
				return acc;
			}

			acc.push(timeClockShift);
			return acc;
		}, []);

		return (
			<EnhancedTable
				rows={rows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'clockOutDateTime'}
				refreshId={this.state.refreshId}
			/>
		);
	};

	renderRecentCompletedShiftsCard = () => {
		const { classes } = this.props;
		const { getLastShiftInfoResult, showRecentlyCompleted } = this.state;
		if (!showRecentlyCompleted) {
			return null;
		}
		return (
			<Card classes={{ root: classes.infoCard }}>
				<div className={clsx(classes.cardTop, classes.recentCardTop)}>
					Recently Completed Shifts
				</div>
				<div className={classes.infoCardContent}>
					{!getLastShiftInfoResult && (
						<div className={classes.globalFetching}>Fetching your shifts...</div>
					)}
					{!!getLastShiftInfoResult && this.renderCompletedShifts()}
				</div>
			</Card>
		);
	};

	render34HourResetCard = () => {
		const { classes } = this.props;
		const { getShiftAnalysisResult, show34HourReset } = this.state;
		if (!show34HourReset) {
			return null;
		}
		return (
			<Card classes={{ root: classes.infoCard }}>
				<div className={clsx(classes.cardTop, classes.resetCardTop)}>34 Hour Rest Info</div>
				<div className={classes.infoCardContent}>
					{!getShiftAnalysisResult && (
						<div className={classes.globalFetching}>Fetching shifts analysis...</div>
					)}
					{!!getShiftAnalysisResult && this.render34HourResetRows()}
				</div>
			</Card>
		);
	};

	render34HourResetRows = () => {
		const { getShiftAnalysisResult, filter, filterTimeClockLocationId } = this.state;

		const { timeClockAnalysisResults } = getShiftAnalysisResult;
		const c = getShiftAnalysisResult.collections;
		const userMap = _.keyBy(_.get(c, 'userCollection', []), 'userId');

		const columns = [
			{ label: 'Employee', sortId: 'fullName', displayId: 'fullName' },
			{
				label: 'Last 34+ Hour Rest',
				sortId: 'last34HourResetStartDateTime',
				displayId: 'last34HourRest',
			},
			{
				label: 'Current Status',
				sortId: 'currentStatus',
				displayId: 'currentStatus',
			},
			{
				label: 'Worked Since Last Rest',
				sortId: 'secondsWorkedSinceLast34HourReset',
				displayId: 'durationSinceReset',
			},
			//{ label : 'Fix', sortId : 'fix', isNotSortable : true, displayId : 'fixButton'}
		];

		const rows = timeClockAnalysisResults.reduce((acc, row) => {
			const {
				isCurrentlyClockedIn,
				last34HourResetStartDateTime,
				last34HourResetEndDateTime,
				secondsWorkedSinceLast34HourReset,
				userId,
				timeClockLocationIdOfLastClockIn,
			} = row;

			if (
				filterTimeClockLocationId &&
				filterTimeClockLocationId !== timeClockLocationIdOfLastClockIn
			) {
				return acc;
			}

			//if (!secondsWorkedSinceLast34HourReset) { return acc; }

			row.key = userId;
			const user = userMap[userId] || { firstName: 'Missing', lastName: '' };
			row.fullName = `${user.firstName} ${user.lastName}`;
			row.firstName = user.firstName;
			row.lastName = user.lastName;
			row.currentStatus = isCurrentlyClockedIn ? <strong>Clocked In</strong> : 'Clocked Out';

			if (last34HourResetStartDateTime) {
				row.last34HourRest = (
					<>
						<div>Start : {moment(last34HourResetStartDateTime).format('M/D h:mm a')}</div>
						<div>End : {moment(last34HourResetEndDateTime).format('M/D h:mm a')}</div>
					</>
				);
			} else {
				row.last34HourRest = '-';
			}

			//row.last34HourResetDateTimeFormatted = moment(last34HourResetStartDateTime).format('M/D h:mm a');
			row.durationSinceReset = moment
				.duration(secondsWorkedSinceLast34HourReset, 'seconds')
				.format('h [hrs], m [min]');

			row.secondsWorkedSinceLast34HourReset = secondsWorkedSinceLast34HourReset || 0;

			if (isFiltered({ filter, row, fields: ['firstName', 'lastName'] })) {
				return acc;
			}

			acc.push(row);
			return acc;
		}, []);

		return (
			<EnhancedTable
				rows={rows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'secondsWorkedSinceLast34HourReset'}
				defaultOrder={'desc'}
			/>
		);
	};
}

TimeClockDashboard.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	getMyTimeClockPermissions: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TimeClockPermissionContainer,
])(TimeClockDashboard);
